
export default {
    name: 'CheckBoxButton',
    props: {
        checked: Boolean,
        disabled: Boolean,
        size: {
            type: String,
            default: () => 'sm',
            validator: v => ['base', 'sm'].includes(v)
        }
    }
}
